import { render, staticRenderFns } from "./CommunityCalendarEventView.vue?vue&type=template&id=011c4262&scoped=true&"
import script from "./CommunityCalendarEventView.vue?vue&type=script&lang=js&"
export * from "./CommunityCalendarEventView.vue?vue&type=script&lang=js&"
import style0 from "./CommunityCalendarEventView.vue?vue&type=style&index=0&id=011c4262&scoped=true&lang=sass&"
import style1 from "./CommunityCalendarEventView.vue?vue&type=style&index=1&id=011c4262&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011c4262",
  null
  
)

export default component.exports